'use strict';

module.exports = Object.freeze({
	MESSAGE: {
	},
	ERROR: {
		403: 'Access Denied',
		440: '參數錯誤或格式不符',
		499: '資料存取錯誤',
		500: '內部伺服器錯誤 (Internal Server Error)'
	},
});
